import NavBar from "./NavBar";
import DevCardsLayout from "./DevCardsLayout";
import Tip from "./Tip";
import React, { useState } from 'react';

const DevProjects = () => {
  const [tip1Visible, setTip1Visible] = useState(true);
  return (
    <>
      <Tip
       onClose={() => setTip1Visible(false)}
 visibility={tip1Visible}
  text="📢 Tip: Live demo will be available soon"
  bottom={10}   
  right={10}    
/>

      <NavBar
        links={[
          { type: "anchor", label: "Home", href: "/" },
          { type: "anchor", label: "About", href: "/" },
          { type: "anchor", label: "Certifications", href: "/Certifications" },
          { type: "anchor", label: "Experience", href: "/" },
          { type: "anchor", label: "Services", href: "/" },
          {
            type: "anchor",
            label: "Projects",
            href: "/",
            children: [
              { type: "anchor", label: "Dev Projects", href: "/DevProjects" },
              { type: "anchor", label: "IT Projects", href: "/ItProjects" },
            ],
          },
          { type: "anchor", label: "Products", href: "/Products" },
          { type: "anchor", label: "Contact", href: "/" },
        ]}
      />

      <h1
        style={{
          backgroundColor: "#0A192F",
          margin: 0,
          padding: 0,
          height: "70px",
        }}
      >
        {" "}
      </h1>

      <DevCardsLayout />
    </>
  );
};

export default DevProjects;
